import { render, staticRenderFns } from "./BuscaPalavraChave.vue?vue&type=template&id=61d17b8a&scoped=true&"
import script from "./buscaPalavraChave.ts?vue&type=script&lang=ts&"
export * from "./buscaPalavraChave.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d17b8a",
  null
  
)

export default component.exports